import { useState, useEffect } from 'react';
import { gql, useApolloClient } from '@apollo/client';
import moment from 'moment';
import toast from 'react-hot-toast';

const useTaskStatus = (task, productSlug) => {
  if (!task) return;

  const checkTaskStatusStart = moment();
  const { uuid: taskUuid, type } = task;

  const client = useApolloClient();
  const [elapsedTime, setElapsedTime] = useState(
    moment.duration(moment() - checkTaskStatusStart).humanize()
  );

  const POLL_TASK_STATUS = gql`
    query TaskStatus($input: TaskStatusInput!) {
      taskStatus(input: $input) {
        task {
          uuid
          status
        }
      }
    }
  `;

  useEffect(() => {
    let checkTaskInterval;
    let toastId;

    if (task) {
      toastId = toast.loading(`${productSlug}\n${type}\npending - ${elapsedTime}`);

      checkTaskInterval = setInterval(async () => {
        const { data } = await client.query({
          fetchPolicy: 'network-only',
          query: POLL_TASK_STATUS,
          variables: {
            input: {
              taskUuid,
            },
          },
        });

        const { task: foundTask } = data.taskStatus;
        const { status } = foundTask;
        const time = moment.duration(moment() - checkTaskStatusStart).humanize();
        setElapsedTime(time);

        const toastStatus = `${productSlug}\n${type}\n${status} - ${time}`;

        if (status !== 'pending') {
          clearInterval(checkTaskInterval);
          return toast.success(toastStatus, { id: toastId });
        }

        toast.loading(toastStatus, { id: toastId });
      }, 5000);
    }

    return () => {
      clearInterval(checkTaskInterval);
      toast.dismiss(toastId);
    };
  }, [task]);
};

export default useTaskStatus;
